<template>
  <v-icon dark :color="color">{{ type }}</v-icon>
</template>
<script>
export default {
  props: ['type', 'color'],
  data: () => ({

  })
}
</script>
